var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "home-container", attrs: { id: "box" } },
    [
      _c(
        "div",
        {
          staticClass: "box_banner_logo",
          staticStyle: { cursor: "pointer" },
          on: {
            click: function ($event) {
              return _vm.home()
            },
          },
        },
        [
          _c("img", {
            staticStyle: {
              width: "68px",
              height: "78px",
              "margin-right": "22px",
            },
            attrs: { src: _vm.httplogo },
          }),
          _c("div", { style: { fontSize: _vm.fontSize + "px" } }, [
            _vm._v(_vm._s(_vm.configdata.projectname)),
          ]),
        ]
      ),
      _c("img", {
        staticStyle: { display: "block", width: "100%", height: "298px" },
        attrs: { src: require("@/assets/register_bg.png") },
      }),
      _c(
        "div",
        { staticClass: "box_content" },
        [
          _c(
            "el-form",
            {
              ref: "ruleForm",
              staticClass: "demo-ruleForm",
              attrs: {
                model: _vm.ruleForm,
                rules: _vm.rules,
                "label-width": "100px",
              },
            },
            [
              _c(
                "el-row",
                {
                  staticStyle: { "margin-bottom": "10px" },
                  attrs: { gutter: 20 },
                },
                [
                  _c(
                    "el-col",
                    {
                      staticStyle: { color: "transparent" },
                      attrs: { span: 4 },
                    },
                    [_vm._v("1")]
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "单位名称", prop: "company" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入单位名称" },
                            model: {
                              value: _vm.ruleForm.company,
                              callback: function ($$v) {
                                _vm.$set(_vm.ruleForm, "company", $$v)
                              },
                              expression: "ruleForm.company",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "信用代码", prop: "yscode" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入信用代码" },
                            model: {
                              value: _vm.ruleForm.yscode,
                              callback: function ($$v) {
                                _vm.$set(_vm.ruleForm, "yscode", $$v)
                              },
                              expression: "ruleForm.yscode",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                {
                  staticStyle: { "margin-bottom": "10px" },
                  attrs: { gutter: 20 },
                },
                [
                  _c(
                    "el-col",
                    {
                      staticStyle: { color: "transparent" },
                      attrs: { span: 4 },
                    },
                    [_vm._v("1")]
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "经办人", prop: "nickName" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入经办人" },
                            model: {
                              value: _vm.ruleForm.nickName,
                              callback: function ($$v) {
                                _vm.$set(_vm.ruleForm, "nickName", $$v)
                              },
                              expression: "ruleForm.nickName",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "手机号码", prop: "phonenumber" } },
                        [
                          _c("el-input", {
                            attrs: {
                              maxlength: "11",
                              placeholder: "请输入手机号码",
                            },
                            model: {
                              value: _vm.ruleForm.phonenumber,
                              callback: function ($$v) {
                                _vm.$set(_vm.ruleForm, "phonenumber", $$v)
                              },
                              expression: "ruleForm.phonenumber",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                {
                  staticStyle: { "margin-bottom": "10px" },
                  attrs: { gutter: 20 },
                },
                [
                  _c(
                    "el-col",
                    {
                      staticStyle: { color: "transparent" },
                      attrs: { span: 4 },
                    },
                    [_vm._v("1")]
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "电子邮箱", prop: "email" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入电子邮箱" },
                            model: {
                              value: _vm.ruleForm.email,
                              callback: function ($$v) {
                                _vm.$set(_vm.ruleForm, "email", $$v)
                              },
                              expression: "ruleForm.email",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "密码", prop: "password" } },
                        [
                          _c("el-input", {
                            attrs: {
                              maxlength: "16",
                              "show-password": "",
                              placeholder: "请输入密码",
                            },
                            model: {
                              value: _vm.ruleForm.password,
                              callback: function ($$v) {
                                _vm.$set(_vm.ruleForm, "password", $$v)
                              },
                              expression: "ruleForm.password",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "flex-direction": "column",
                    "margin-left": "0",
                  },
                },
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: { width: "520px", margin: "10px auto" },
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.submitForm("ruleForm")
                        },
                      },
                    },
                    [_vm._v("立即注册")]
                  ),
                  _c(
                    "el-button",
                    {
                      staticStyle: { margin: "10px auto", width: "520px" },
                      on: {
                        click: function ($event) {
                          return _vm.resetForm("ruleForm")
                        },
                      },
                    },
                    [_vm._v("返回登录")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("Footer"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }